// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonLink_button__2CuFU","button__text":"ButtonLink_button__text__3rPyP"};